import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowCircleDown} from '@fortawesome/pro-solid-svg-icons';
import {canCreatePdfFromAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionCreatePDFDownloadIcon = faArrowCircleDown;

/**
 * Create and download pdf from asset
 * @param params
 * @returns Action
 */
export const assetActionCreatePDFDownload = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-create-pdf-download',
	cb: () => dispatcher.trigger(ASSET_EVENT.CREATE_PDF_DOWNLOAD, asset),
	enableTest: () => canCreatePdfFromAsset(asset),
	icon: assetActionCreatePDFDownloadIcon,
	get label() {
		return AssetActionLabel.CREATE_PDF_DOWNLOAD;
	},
	...params,
});

export default assetActionCreatePDFDownload;
